export const BLOCKCHAIN_DATA_LOADED = "BLOCKCHAIN_DATA_LOADED"

export function vslaIsLoading(state = false, action) {
  switch (action.type) {
    case "LOAD_VSLA_START":
      return action.isloading
    default:
      return state
  }
}

export function vsla(state = null, action) {
  switch (action.type) {
    case BLOCKCHAIN_DATA_LOADED:
      return action.payload
    default:
      return state
  }
}

export function vslaHasErrored(state = false, action) {
  switch (action.type) {
    case "LOAD_VSLA_ERROR":
      return action.error
    default:
      return state
  }
}
